import { render, staticRenderFns } from "./EditDriverWallet.vue?vue&type=template&id=4435e496&"
import script from "./EditDriverWallet.vue?vue&type=script&lang=js&"
export * from "./EditDriverWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports